import React from 'react';
import { Route, Redirect, Switch, RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { getStartPage } from 'config/pages';

import { IRootState } from 'reducers';

import LoginPage from './components/LoginPage';

type Props = ReturnType<typeof mapStateToProps> & RouteComponentProps;

const AuthPage: React.FC<Props> = ({ isAuthenticated, roles }) => (
  <Switch>
    {isAuthenticated &&
      <Redirect exact={false} from="/auth" to={getStartPage(roles)} />
    }
    <Redirect exact={true} from="/auth" to="/auth/login" />
    <Route path={'/auth'} component={LoginPage} />
  </Switch>
);

const mapStateToProps = ({ user: { isAuthenticated, roles } }: IRootState) => ({
  isAuthenticated,
  roles,
});

export default connect(mapStateToProps)(AuthPage);
